// extracted by mini-css-extract-plugin
export default {"table-body":"Body_table-body__qwg2s","table-body-wrp":"Body_table-body-wrp__jhtaq","body":"Body_body__lpN6g"};